import * as React from 'react';

import AnswerBadge from '../../../__components/AnswerBadge';
import type { BadgeTypes } from '../../../__components/AnswerBadge/__types__';
import ForumItemCard from '../../../__components/ForumItemCard';
import ForumItemReplyList from '../../../__components/ForumItemReplyList';
import type { ForumPostWithCreator } from '../../../__providers__/ForumPostDataProvider/__types__';

const FORUM_ITEM_CARD_DATA_ID = 'forums-v2-item-card';

export default function ReplyList({
  replies,
  showReplyControls,
  children,
}: {
  replies: ForumPostWithCreator[];
  children?: ({ reply }: { reply: ForumPostWithCreator }) => null | JSX.Element;
  showReplyControls?: boolean;
}) {
  const getFirstForumItemCardButton = (): HTMLButtonElement | undefined => {
    const cards = document.querySelectorAll(`[data-testid="${FORUM_ITEM_CARD_DATA_ID}"]`);
    if (!cards || cards.length < 1) return undefined;
    const cardsArray = Array.from(cards);
    const firstCard = cardsArray[0] as HTMLElement;
    const itemCardButtons = firstCard.querySelectorAll('button:not([disabled])') as NodeListOf<HTMLButtonElement>;
    if (itemCardButtons) {
      return itemCardButtons[itemCardButtons.length - 1];
    }
    return undefined;
  };

  const handleDeleteSuccess = () => {
    const itemCardButton = getFirstForumItemCardButton();
    if (itemCardButton) {
      setTimeout(() => {
        itemCardButton.focus();
        // delaying by 500ms to make sure the dom process of removing the deleted item from dom is completed
        // before attempting to adjust focus back to the question
      }, 500);
    }
  };

  return (
    <ForumItemReplyList>
      {replies &&
        replies.map((reply) => {
          return (
            <ForumItemCard
              key={reply?.id}
              dataTestId={FORUM_ITEM_CARD_DATA_ID}
              replyPost={reply}
              cmlContent={reply.content.details}
              onDeleteSuccess={handleDeleteSuccess}
              tags={
                <>
                  {reply?.answerBadge?.answerBadge && reply.answerBadge.answerBadge === 'HIGHLIGHTED' && (
                    <AnswerBadge answerBadge={reply.answerBadge.answerBadge} />
                  )}
                  {reply?.creator?.courseRole && <AnswerBadge answerBadge={reply.creator?.courseRole as BadgeTypes} />}
                </>
              }
              {...reply}
              replyCount={showReplyControls ? reply.topLevelAnswerCount : undefined}
              forumQuestionId={reply.forumQuestionId}
            >
              {children && typeof children === 'function' && children({ reply })}
              {children && typeof children !== 'function' && children}
            </ForumItemCard>
          );
        })}
    </ForumItemReplyList>
  );
}
